import { createContext, useContext } from 'react';

/**
 * Telefonos nézetben vagyunk-e. (3.0 / 8.)
 *
 * A megjelenés nagy részét a `body.mobil` osztály intézi a stíluslapban.
 * Ez a jelzés csak ott kell, ahol nem elég átrendezni: a raktári lista
 * telefonon **kártyákká alakul**, mert egy kilenc oszlopos táblázat
 * használhatatlan egy sofőr kezében.
 */
export const MobilContext = createContext(false);

export function useMobil(): boolean {
  return useContext(MobilContext);
}
